import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import headerMenu from "../components/shop/HeaderMenu.vue";
import OrderList from "../components/shop/OrderList.vue";
import CustomerList from "../components/shop/CustomerList.vue";
import RebateSetting from "../components/shop/RebateSetting.vue";
import RebateList from "../components/shop/RebateList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopIndex',
  setup(__props) {

const tabs = ref([
  {
    name: "Customer List",
    component: "CustomerList",
    id: 1,
  },

  {
    name: "Order List",
    component: "OrderList",
    id: 3,
  },
  {
    name: "Rebate List",
    component: "RebateList",
    id: 4,
  },
  {
    name: "Rebate Setting",
    component: "RebateSetting",
    id: 5,
  },
]);
const componentMap = {
  OrderList,
  CustomerList,
  RebateSetting,
  RebateList,
};
const currentTab = ref(1);

const handleTabs = (id: number) => {
  currentTab.value = id;
};

const getComponent = (componentName: string) => {
  return componentMap[componentName];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(headerMenu, {
      tabs: tabs.value,
      onChangeTab: handleTabs
    }, null, 8, ["tabs"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.id
      }, [
        (currentTab.value === tab.id)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(tab.component)), { key: 0 }))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}
}

})